import React from "react";
import { useAssetUrl } from "../../hooks/loras/useAssetUrl";

interface CheckpointSampleThumbnailProps {
  /** First entry of checkpoint.sampleInferenceAssetIds (the in-loop preview). */
  assetId: string | null | undefined;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Renders a LoRA checkpoint's in-loop sample preview from its asset id
 * (Phase 4). Resolves the id to a signed URL via `useAssetUrl`. Renders a
 * subtle placeholder while loading or when no sample exists yet, so the
 * caller can always mount it unconditionally.
 */
export const CheckpointSampleThumbnail: React.FC<
  CheckpointSampleThumbnailProps
> = ({ assetId, alt, className, style }) => {
  const { data: url, isLoading } = useAssetUrl(assetId);

  if (assetId && url) {
    return (
      <img
        src={url}
        alt={alt ?? "Checkpoint sample"}
        className={className}
        style={{ objectFit: "cover", ...style }}
        loading="lazy"
      />
    );
  }

  return (
    <div
      className={className}
      aria-busy={isLoading || undefined}
      style={{ background: "rgba(255, 255, 255, 0.06)", ...style }}
    />
  );
};

export default CheckpointSampleThumbnail;
